import Dexie from 'dexie';
import { TABLE_TYPE as LOFT_TABLE_TYPE } from './repositories/LoftRepo';
import { TABLE_TYPE as ERROR_LOG_TABLE_TYPE } from './repositories/ErrorLogRepo';
import { TABLE_TYPE as HEAD_FINISH_TABLE_TYPE } from './repositories/HeadFinishRepo';
import { TABLE_TYPE as HEAD_FINISH_WEDGE_TABLE_TYPE } from './repositories/HeadFinishWedgeRepo';
import { TABLE_TYPE as DB_METADATA_TABLE_TYPE } from './repositories/DBMetadataRepo';
import { TABLE_TYPE as USER_SESSION_TABLE_TYPE } from './repositories/UserSessionRepo';
import { TABLE_TYPE as PLAYER_TABLE_TYPE } from './repositories/PlayerRepo';
import { TABLE_TYPE as ACCOUNT_TABLE_TYPE } from './repositories/AccountRepo';
import { TABLE_TYPE as ACTIVE_PLAYER_TABLE_TYPE } from './repositories/ActivePlayerRepo';
import { TABLE_TYPE as MY_PLAYER_TABLE_TYPE } from './repositories/MyPlayerRepo';
import { TABLE_TYPE as OFFLINE_QUEUE_TABLE_TYPE } from './repositories/OfflineQueueRepo';
import { TABLE_TYPE as TOUR_BAG_TABLE_TYPE } from './repositories/TourBagRepo';
import { TABLE_TYPE as HEAD_TYPE_LOFT_TYPE } from './repositories/HeadTypeLoftRepo';
import { TABLE_TYPE as HEAD_TYPE_FAMILY_TYPE } from './repositories/HeadTypeFamilyRepo';
import { TABLE_TYPE as FAMILY_TYPE } from './repositories/FamilyRepo';
import { TABLE_TYPE as FED_EX_CUP_PLAYER } from './repositories/FedExCupPlayerRepo';
import { TABLE_TYPE as HEAD_MODEL_HAND_TYPE } from './repositories/HeadModelHandsForDropdownRepo';
import { TABLE_TYPE as HEAD_MODEL_FOR_DROPDOWN_TYPE } from './repositories/HeadModelByManufacturerAndTypeForDropdownRepo';
import { TABLE_TYPE as HEAD_MODEL_FOR_DROPDOWN_HYBRID_TYPE } from './repositories/HeadModelsByManufacturerAndTypeForDropdownHybridRepo';
import { TABLE_TYPE as HEAD_MODEL_FOR_DROPDOWN_FAIRWAY_TYPE } from './repositories/HeadModelsByManufacturerAndTypeForDropdownFairwayRepo';
import { TABLE_TYPE as HEAD_MODEL_FOR_DROPDOWN_WEDGES_TYPE } from './repositories/HeadModelByManufacturerAndTypeForDropdownWedgesRepo';
import { TABLE_TYPE as IRON_HEAD_MODEL_FOR_DROPDOWN_TYPE } from './repositories/IronHeadModelsByManufacturerAndTypeForDropdownRepo';
import { TABLE_TYPE as HAND_LOOKUP_TYPE } from './repositories/HandLookupRepo';
import { TABLE_TYPE as CT_LOCATION_TYPE } from './repositories/CtLocationRepo';
import { TABLE_TYPE as SETTING_TYPE } from './repositories/SettingRepo';
import { TABLE_TYPE as SLEEVE_TYPE } from './repositories/SleeveRepo';
import { TABLE_TYPE as SWING_WT_PREFIX_TYPE } from './repositories/SwingWtPrefixRepo';
import { TABLE_TYPE as SWING_WT_SUFFIX_TYPE } from './repositories/SwingWtSuffixRepo';
import { TABLE_TYPE as GRIP_SIZE_TYPE } from './repositories/GripSizeRepo';
import { TABLE_TYPE as FRACTION_TYPE } from './repositories/FractionRepo';
import { TABLE_TYPE as HEAD_WEIGHT_LOCATION_LOOKUP_TYPE } from './repositories/HeadWeightLocationLookupRepo';
import { TABLE_TYPE as HEAD_WEIGHT_LOCATION_TYPE } from './repositories/HeadWeightLocationRepo';
import { TABLE_TYPE as HEAD_WEIGHT_NUMBER_LOOKUP_TYPE } from './repositories/HeadWeightNumberLookupRepo';
import { TABLE_TYPE as HEAD_WEIGHT_NUMBER_TYPE } from './repositories/HeadWeightNumberRepo';
import { TABLE_TYPE as HEAD_WEIGHT_LOCATION_AFT_TYPE } from './repositories/HeadWeightLocationAftRepo';
import { TABLE_TYPE as HEAD_WEIGHT_LOCATION_BACK_TYPE } from './repositories/HeadWeightLocationBackRepo';
import { TABLE_TYPE as HEAD_WEIGHT_NUMBER_AFT_TYPE } from './repositories/HeadWeightNumberAftRepo';
import { TABLE_TYPE as HEAD_WEIGHT_NUMBER_BACK_TYPE } from './repositories/HeadWeightNumberBackRepo';
import { TABLE_TYPE as SHAFT_BY_SHAFT_NAME_FOR_DROPDOWN_TYPE } from './repositories/ShaftByShaftNameForDropdownRepo';
import { TABLE_TYPE as IRON_SHAFT_BY_SHAFT_NAME_FOR_DROPDOWN_TYPE } from './repositories/IronShaftByShaftNameForDropdownRepo';
import { TABLE_TYPE as WEDGE_SHAFT_BY_SHAFT_NAME_FOR_DROPDOWN_TYPE } from './repositories/WedgeShaftByShaftNameForDropdownRepo';
import { TABLE_TYPE as HYBRID_SHAFT_BY_SHAFT_NAME_FOR_DROPDOWN_TYPE } from './repositories/HybridShaftByShaftNameForDropdownRepo';
import { TABLE_TYPE as SHAFT_LENGTH_DIGIT_TYPE } from './repositories/ShaftLengthDigitRepo';
import { TABLE_TYPE as SHAFT_LENGTH_FRACTION_TYPE } from './repositories/ShaftLengthFractionRepo';
import { TABLE_TYPE as SHAFT_TIPPING_FRACTION_TYPE } from './repositories/ShaftTippingFractionRepo';
import { TABLE_TYPE as GRIP_TYPE_TYPE } from './repositories/GripTypeRepo';
import { TABLE_TYPE as DIGIT_TYPE } from './repositories/DigitRepo';
import { TABLE_TYPE as LIE_DIGIT_TYPE } from './repositories/LieDigitRepo';
import { TABLE_TYPE as LIE_FRACTION_TYPE } from './repositories/LieFractionRepo';
import { TABLE_TYPE as LOFT_DIGIT_TYPE } from './repositories/LoftDigitRepo';
import { TABLE_TYPE as LOFT_FRACTION_TYPE } from './repositories/LoftFractionRepo';
import { TABLE_TYPE as PUTTER_FACE_TABLE_TYPE } from './repositories/PutterFaceRepo';
import { TABLE_TYPE as PUTTER_GRIP_TABLE_TYPE } from './repositories/PutterGripRepo';
import { TABLE_TYPE as PUTTER_HEAD_FINISH_TABLE_TYPE } from './repositories/PutterHeadFinishRepo';
import { TABLE_TYPE as PUTTER_HEAD_MODEL_TABLE_TYPE } from './repositories/PutterHeadModelRepo';
import { TABLE_TYPE as PUTTER_LEVEL_TABLE_TYPE } from './repositories/PutterLevelRepo';
import { TABLE_TYPE as PUTTER_NECK_TABLE_TYPE } from './repositories/PutterNeckRepo';
import { TABLE_TYPE as PUTTER_SIGHTLINE_TABLE_TYPE } from './repositories/PutterSightlineRepo';
import { TABLE_TYPE as PUTTER_SHAFT_TABLE_TYPE } from './repositories/PutterShaftRepo';
import { TABLE_TYPE as PUTTER_TYPE_TABLE_TYPE } from './repositories/PutterTypeRepo';
import { TABLE_TYPE as PUTTER_WEIGHT_TABLE_TYPE } from './repositories/PutterWeightRepo';
import { TABLE_TYPE as IRON_CLUB_TABLE_TYPE } from './repositories/IronClubRepo';
import { TABLE_TYPE as BSG_BALL_TABLE_TYPE } from './repositories/BsgBallRepo';
import { TABLE_TYPE as BSG_GLOVE_TABLE_TYPE } from './repositories/BsgGloveRepo';
import { TABLE_TYPE as BSG_GLOVE_SIZE_TABLE_TYPE } from './repositories/BsgGloveSizeRepo';
import { TABLE_TYPE as BSG_HEADWEAR_TABLE_TYPE } from './repositories/BsgHeadwearRepo';
import { TABLE_TYPE as BSG_SHOE_TABLE_TYPE } from './repositories/BsgShoeRepo';
import { TABLE_TYPE as BSG_SHOE_SIZE_TABLE_TYPE } from './repositories/BsgShoeSizeRepo';
import { TABLE_TYPE as BSG_SHOE_WIDTH_TABLE_TYPE } from './repositories/BsgShoeWidthRepo';
import { TABLE_TYPE as APP_SETTINGS_TABLE_TYPE } from './repositories/AppSettingsRepo';
import { TABLE_TYPE as GOLF_BAG_TABLE_TYPE } from './repositories/GolfBagRepo';
import { TABLE_TYPE as TOUR_TABLE_TYPE } from './repositories/TourRepo';
import { TABLE_TYPE as LOFTS_AND_HAND_AND_HEAD_MODEL_TABLE_TYPE } from './repositories/LoftsAndHandAndHeadModelRepo';
import { TABLE_TYPE as APP_MENU_TABLE_TYPE } from './repositories/AppMenuRepo';
import { TABLE_TYPE as PLAYER_REGION_LOOKUS_TABLE_TYPE } from './repositories/PlayerRegionLookupsRepo';
import { TABLE_TYPE as PLAYER_STATUS_LOOKUS_TABLE_TYPE } from './repositories/PlayerStatusLookupsRepo';
import { TABLE_TYPE as PLAYER_INTERNAL_STATUSES_TABLE_TYPE } from './repositories/PlayerInternalStatusesRepo';
import { TABLE_TYPE as INTERNAL_STATUS_LOOKUPS_TABLE_TYPE } from './repositories/InternalStatusLookupsRepo';
import { TABLE_TYPE as NATIONALITY_TABLE_TYPE } from './repositories/NationalityRepo';
import { TABLE_TYPE as PLAYER_COLLEGE_LOOKUP_TABLE_TYPE } from './repositories/PlayerCollegeLookupRepo';
import { TABLE_TYPE as PLAYER_YEAR_LOOKUP_TABLE_TYPE } from './repositories/PlayerYearLookupRepo';
import { TABLE_TYPE as PLAYER_SUPPORT_LOOKUP_TABLE_TYPE } from './repositories/PlayerSupportLookupRepo';
import { TABLE_TYPE as ORDER_ACCOUNTS_FOR_DROPDOWN_TABLE_TYPE } from './repositories/OrderAccountsForDropdownRepo';
import { TABLE_TYPE as ORDER_STATUS_LIST_TABLE_TYPE } from './repositories/OrderStatusListRepo';
import { TABLE_TYPE as BUILD_LOCATIONS_FOR_DROPDOWN } from './repositories/BuildLocationsForDropdownRepo';
import { TABLE_TYPE as APP_USERS_FOR_DROPDOWN } from './repositories/AppUserForDropdown';
import { TABLE_TYPE as ORDERS_CACHE_TABLE_TYPE } from './repositories/OrdersRepo';
import { TABLE_TYPE as NOTIFICATION_EVENT_TYPE_TABLE_TYPE } from './repositories/NotificationEventTypeRepo';
import { TABLE_TYPE as TOURNAMENT_TABLE_TYPE } from './repositories/TournamentRepo';

// The configured version is the baseline
const DATABASE_VERSION = Number(import.meta.env.TOURPWA_DATABASE_VERSION || 1) + 2;
const DATABASE_NAME = import.meta.env.TOURPWA_DATABASE_NAME || 'TourApp';

export type Key = string | number;

// Disable ESLint for unused params in interface declaration
/* eslint-disable no-unused-vars */
export interface DataRepository<T> {
  get: (key: Key) => Promise<T | undefined>;
  list: () => Promise<T[]>;
  update: (payload: T, key: Key) => Promise<T>;
  bulkAdd: (payload: T[]) => Promise<T[]>;
}
/* eslint-enable no-unused-vars */

export class Database extends Dexie {
  loft!: LOFT_TABLE_TYPE;
  errorLog!: ERROR_LOG_TABLE_TYPE;
  headFinish!: HEAD_FINISH_TABLE_TYPE;
  headFinishWedge!: HEAD_FINISH_WEDGE_TABLE_TYPE;
  dbMetadata!: DB_METADATA_TABLE_TYPE;
  userSession!: USER_SESSION_TABLE_TYPE;
  player!: PLAYER_TABLE_TYPE;
  account!: ACCOUNT_TABLE_TYPE;
  activePlayer!: ACTIVE_PLAYER_TABLE_TYPE;
  myPlayer!: MY_PLAYER_TABLE_TYPE;
  offlineQueue!: OFFLINE_QUEUE_TABLE_TYPE;
  tourBag!: TOUR_BAG_TABLE_TYPE;
  headTypeLoft!: HEAD_TYPE_LOFT_TYPE;
  headTypeFamily!: HEAD_TYPE_FAMILY_TYPE;
  family!: FAMILY_TYPE;
  fedExCupPlayer!: FED_EX_CUP_PLAYER;
  headModelHand!: HEAD_MODEL_HAND_TYPE;
  headModelForDropdownDto!: HEAD_MODEL_FOR_DROPDOWN_TYPE;
  headModelForDropdownDtoHybrid!: HEAD_MODEL_FOR_DROPDOWN_HYBRID_TYPE;
  headModelForDropdownDtoFairway!: HEAD_MODEL_FOR_DROPDOWN_FAIRWAY_TYPE;
  headModelForDropdownDtoWedges!: HEAD_MODEL_FOR_DROPDOWN_WEDGES_TYPE;
  ironHeadModelForDropdownDto!: IRON_HEAD_MODEL_FOR_DROPDOWN_TYPE;
  handLookup!: HAND_LOOKUP_TYPE;
  ctLocation!: CT_LOCATION_TYPE;
  setting!: SETTING_TYPE;
  sleeve!: SLEEVE_TYPE;
  swingWtPrefix!: SWING_WT_PREFIX_TYPE;
  swingWtSuffix!: SWING_WT_SUFFIX_TYPE;
  gripSize!: GRIP_SIZE_TYPE;
  gripType!: GRIP_TYPE_TYPE;
  fraction!: FRACTION_TYPE;
  headWeightLocationLookup!: HEAD_WEIGHT_LOCATION_LOOKUP_TYPE;
  headWeightLocation!: HEAD_WEIGHT_LOCATION_TYPE;
  headWeightNumberLookup!: HEAD_WEIGHT_NUMBER_LOOKUP_TYPE;
  headWeightNumber!: HEAD_WEIGHT_NUMBER_TYPE;
  headWeightLocationAft!: HEAD_WEIGHT_LOCATION_AFT_TYPE;
  headWeightLocationBack!: HEAD_WEIGHT_LOCATION_BACK_TYPE;
  headWeightNumberAft!: HEAD_WEIGHT_NUMBER_AFT_TYPE;
  headWeightNumberBack!: HEAD_WEIGHT_NUMBER_BACK_TYPE;
  shaftByShaftNameForDropdown!: SHAFT_BY_SHAFT_NAME_FOR_DROPDOWN_TYPE;
  ironShaftByShaftNameForDropdown!: IRON_SHAFT_BY_SHAFT_NAME_FOR_DROPDOWN_TYPE;
  wedgeShaftByShaftNameForDropdown!: WEDGE_SHAFT_BY_SHAFT_NAME_FOR_DROPDOWN_TYPE;
  hybridShaftByShaftNameForDropdown!: HYBRID_SHAFT_BY_SHAFT_NAME_FOR_DROPDOWN_TYPE;
  shaftLengthDigit!: SHAFT_LENGTH_DIGIT_TYPE;
  shaftLengthFraction!: SHAFT_LENGTH_FRACTION_TYPE;
  shaftTippingFraction!: SHAFT_TIPPING_FRACTION_TYPE;
  digit!: DIGIT_TYPE;
  lieDigit!: LIE_DIGIT_TYPE;
  lieFraction!: LIE_FRACTION_TYPE;
  loftDigit!: LOFT_DIGIT_TYPE;
  loftFraction!: LOFT_FRACTION_TYPE;
  putterFace!: PUTTER_FACE_TABLE_TYPE;
  putterGrip!: PUTTER_GRIP_TABLE_TYPE;
  putterHeadFinish!: PUTTER_HEAD_FINISH_TABLE_TYPE;
  putterHeadModel!: PUTTER_HEAD_MODEL_TABLE_TYPE;
  putterLevel!: PUTTER_LEVEL_TABLE_TYPE;
  putterNeck!: PUTTER_NECK_TABLE_TYPE;
  putterSightline!: PUTTER_SIGHTLINE_TABLE_TYPE;
  putterShaft!: PUTTER_SHAFT_TABLE_TYPE;
  putterType!: PUTTER_TYPE_TABLE_TYPE;
  putterWeight!: PUTTER_WEIGHT_TABLE_TYPE;
  ironClub!: IRON_CLUB_TABLE_TYPE;
  bsgBall!: BSG_BALL_TABLE_TYPE;
  bsgGlove!: BSG_GLOVE_TABLE_TYPE;
  bsgGloveSize!: BSG_GLOVE_SIZE_TABLE_TYPE;
  bsgHeadwear!: BSG_HEADWEAR_TABLE_TYPE;
  bsgShoe!: BSG_SHOE_TABLE_TYPE;
  bsgShoeSize!: BSG_SHOE_SIZE_TABLE_TYPE;
  bsgShoeWidth!: BSG_SHOE_WIDTH_TABLE_TYPE;
  appSettings!: APP_SETTINGS_TABLE_TYPE;
  golfBag!: GOLF_BAG_TABLE_TYPE;
  tour!: TOUR_TABLE_TYPE;
  loftsAndHandAndHeadModel!: LOFTS_AND_HAND_AND_HEAD_MODEL_TABLE_TYPE;
  appMenu!: APP_MENU_TABLE_TYPE;
  playerRegionLookups!: PLAYER_REGION_LOOKUS_TABLE_TYPE;
  playerStatusLookups!: PLAYER_STATUS_LOOKUS_TABLE_TYPE;
  playerInternalStatuses!: PLAYER_INTERNAL_STATUSES_TABLE_TYPE;
  internalStatusLookups!: INTERNAL_STATUS_LOOKUPS_TABLE_TYPE;
  nationality!: NATIONALITY_TABLE_TYPE;
  playerCollegeLookup!: PLAYER_COLLEGE_LOOKUP_TABLE_TYPE;
  playerYearLookup!: PLAYER_YEAR_LOOKUP_TABLE_TYPE;
  playerSupportLookup!: PLAYER_SUPPORT_LOOKUP_TABLE_TYPE;
  orderAccountsForDropdown!: ORDER_ACCOUNTS_FOR_DROPDOWN_TABLE_TYPE;
  orderStatusList!: ORDER_STATUS_LIST_TABLE_TYPE;
  buildLocationsForDropdown!: BUILD_LOCATIONS_FOR_DROPDOWN;
  appUserForDropdown!: APP_USERS_FOR_DROPDOWN;
  ordersCache!: ORDERS_CACHE_TABLE_TYPE;
  tournament!: TOURNAMENT_TABLE_TYPE;
  notificationEventTypes!: NOTIFICATION_EVENT_TYPE_TABLE_TYPE;

  constructor(databaseName: string) {
    super(databaseName);
  }

  /**
   * @param {string} tableName
   * @param {string} schema dexie string schema values
   * @link https://dexie.org/docs/Version/Version.stores()#detailed-schema-syntax
   */
  registerModelSchema(tableName: string, schema: string) {
    // avoid crashing when working with hot reload
    if (!this.isOpen()) {
      this.version(DATABASE_VERSION).stores({
        [tableName]: schema,
      });
    }
  }
}

const db = new Database(DATABASE_NAME);

export default db;
